import React, { useState } from 'react';
import styles from '../styles/panelList.module.css';

interface PanelItem {
  title: string;
  subtext: string;
  link_type: 'external' | 'document' | 'route';
  link_value: string;
}

interface PanelListLinksProps {
  title: string;
  subtext: string;
  items: PanelItem[];
  isExpanded?: boolean;
}

const PanelListLinks: React.FC<PanelListLinksProps> = ({
  title,
  subtext,
  items,
  isExpanded = false
}) => {
  const [expanded, setExpanded] = useState(isExpanded);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const handleItemClick = (item: PanelItem) => {
    if (item.link_type === 'external' || item.link_type === 'document') {
      window.open(item.link_value, '_blank');
    } else if (item.link_type === 'route') {
      window.location.href = item.link_value;
    }
  };

  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader} onClick={toggleExpanded}>
        <div className={styles.panelTitleSection}>
          <h3 className={styles.panelTitle}>{title}</h3>
          {subtext && <p className={styles.panelSubtext}>{subtext}</p>}
        </div>
        <button 
          className={`${styles.expandButton} ${expanded ? styles.expanded : ''}`}
          aria-label={expanded ? 'Collapse' : 'Expand'}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
      </div>
      
      {expanded && (
        <div className={styles.panelContent}>
          <div className={styles.linksList}>
            {items.map((item, index) => (
              <div 
                key={index} 
                className={styles.linkListItem}
                onClick={() => handleItemClick(item)}
              >
                <div className={styles.linkContent}>
                  <h4 className={styles.linkTitle}>{item.title}</h4>
                  <p className={styles.linkSubtext}>{item.subtext}</p>
                </div>
                <div className={styles.linkIcon}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                    <polyline points="15 3 21 3 21 9" />
                    <line x1="10" y1="14" x2="21" y2="3" />
                  </svg>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PanelListLinks;



